import axios from 'axios';

/*
 * Rotte del backend per l'app Player (sportid-docs, «Interventi BE e MANAGER per APP PLAYER del 7-8 ottobre
 * 2026»): pagine dell'app modificabili, versione minima dell'app, galleria e video della struttura, video di
 * presentazione con l'approvazione del super admin.
 *
 * Ogni chiamata restituisce i dati, oppure { error, status } con il motivo del server.
 */

const token = () => {
    try { return JSON.parse(sessionStorage.getItem('userDetails')).idToken; } catch { return ''; }
};
const basePath = () => String(process.env.REACT_APP_API_BASE_PATH || '').replace(/\/+$/, '');
const chiama = async (method, path, data) => {
    try {
        const r = await axios.request({ method, url: `${basePath()}${path}`, data, headers: { authorization: token(), accept: 'application/json', 'Content-Type': 'application/json' } });
        return r.data ?? {};
    } catch (e) {
        return { error: e.response?.data?.detail || e.response?.data?.message || 'Errore generico', status: e.response?.status };
    }
};
const q = (clubId) => (clubId ? `?clubId=${encodeURIComponent(clubId)}` : '');

/** Da un file scelto al base64 senza il prefisso `data:` che il backend non vuole. */
export const fileInBase64 = (file) => new Promise((resolve, reject) => {
    const lettore = new FileReader();
    lettore.onload = () => resolve(String(lettore.result).replace(/^data:[^;]+;base64,/, ''));
    lettore.onerror = () => reject(lettore.error);
    lettore.readAsDataURL(file);
});

/* ── Pagine dell'app (super admin) ───────────────────────────── */

/** L'indirizzo da cui l'app (e l'anteprima) legge le immagini delle pagine. */
export const urlImmaginePagina = (src) => `${basePath()}/${String(src || '').replace(/^\/+/, '')}`;

export const elencoPagineApp = () => chiama('get', '/administration/appPages');
export const leggiPaginaApp = (slug) => chiama('get', `/administration/appPages/${encodeURIComponent(slug)}`);
export const aggiornaPaginaApp = (slug, modifiche) => chiama('patch', `/administration/appPages/${encodeURIComponent(slug)}`, modifiche);
export const cronologiaPaginaApp = (slug) => chiama('get', `/administration/appPages/${encodeURIComponent(slug)}/history`);
export const elencoImmaginiPagine = () => chiama('get', '/administration/appPages/images');
export const caricaImmaginePagina = async (file, nome) =>
    chiama('post', '/administration/appPages/images', { fileName: nome || file.name, content: await fileInBase64(file) });

/* ── Versione minima dell'app (super admin) ──────────────────── */

export const leggiVersioniMinime = () => chiama('get', '/administration/settings/appMinimumBuilds');
export const salvaVersioniMinime = (versioni) => chiama('put', '/administration/settings/appMinimumBuilds', versioni);

/* ── Galleria della struttura ────────────────────────────────── */

/** `immagine` e` il base64 del ritaglio (ProductImageUploader), anche con il prefisso `data:`. */
export const aggiungiFotoGalleria = (immagine, nome, caption) =>
    chiama('post', '/profile/gallery', { name: nome, content: immagine, caption: caption || null });
export const cambiaDidascalia = (pictureId, caption) => chiama('patch', `/profile/pictures/${encodeURIComponent(pictureId)}`, { caption: caption || null });
export const riordinaGalleria = (pictureIds) => chiama('put', '/profile/gallery/order', { pictureIds });
export const togliFotoGalleria = (pictureId) => chiama('delete', `/profile/pictures/${encodeURIComponent(pictureId)}`);

/* ── Video di presentazione ──────────────────────────────────── */

export const statoVideoPresentazione = (clubId) => chiama('get', `/profile/introVideo${q(clubId)}`);

/**
 * Il file va direttamente su S3 con un indirizzo firmato (troppo grande per il backend), poi si conferma:
 * il backend controlla formato, durata e verticale e risponde con lo stato.
 */
export const caricaVideoPresentazione = async (file, clubId, onProgresso) => {
    const indirizzo = await chiama('post', `/profile/introVideo/uploadUrl${q(clubId)}`);
    if (indirizzo.error) return indirizzo;
    if (file.size > indirizzo.maxBytes) return { error: 'Il video supera i 15 MB.' };
    try {
        await axios.put(indirizzo.uploadUrl, file, {
            headers: { 'Content-Type': indirizzo.contentType },
            onUploadProgress: (e) => onProgresso?.(e.total ? e.loaded / e.total : 0),
        });
    } catch {
        return { error: 'Il caricamento del video non è riuscito: controlla la connessione e riprova.' };
    }
    return chiama('post', `/profile/introVideo${q(clubId)}`, { uploadId: indirizzo.uploadId });
};

export const togliVideoPresentazione = (clubId) => chiama('delete', `/profile/introVideo${q(clubId)}`);
export const videoDaApprovare = () => chiama('get', '/profile/introVideos/pending');
export const approvaVideo = (clubId) => chiama('post', `/profile/introVideos/${encodeURIComponent(clubId)}/approve`);
export const rifiutaVideo = (clubId, reason) => chiama('post', `/profile/introVideos/${encodeURIComponent(clubId)}/reject`, { reason });

/* ── Opzioni della scheda della struttura (stile, soci, video con link) ── */

export const leggiProfilo = () => chiama('get', '/profile');
export const salvaOpzioniScheda = (club) => chiama('patch', '/profile', { club });
